import { render } from "./GrantTrial.vue?vue&type=template&id=2009d500&scoped=true"
import script from "./GrantTrial.vue?vue&type=script&lang=js"
export * from "./GrantTrial.vue?vue&type=script&lang=js"

import "./GrantTrial.vue?vue&type=style&index=0&id=2009d500&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2009d500"]])

export default __exports__